import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import gtm from '../../../general/js/gtm';
import { displayRightHeaderLinkByOneClubMembership } from './right-header-link-item-helpers';

class RightHeaderLinkItem extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        displayRightHeaderLinkByOneClubMembership(this.element);
        this.addListener(this.element, 'click', this.saveActionToGtm);
    }

    saveActionToGtm = (event) => {
        const clickedItem = event.target;
        const itemText = clickedItem.innerText || clickedItem.textContent;
        gtm.push('Top Ribbon', 'Click', itemText);
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }
}

export default RightHeaderLinkItem;
